import React from "react";
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar, PieChart, Pie, Cell, Legend } from "recharts";

const PALETTE = ["#2563eb", "#dc2626", "#ea580c", "#059669", "#7c3aed", "#0284c7", "#db2777", "#ca8a04", "#0891b2", "#64748b"];

export function SentimentLine({ data }) {
  return (
    <ResponsiveContainer width="100%" height={180}>
      <AreaChart data={data} margin={{ top: 10, right: 10, left: -12, bottom: 0 }}>
        <defs>
          <linearGradient id="sGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#2563eb" stopOpacity={0.3} />
            <stop offset="100%" stopColor="#2563eb" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="2 4" stroke="#e2e8f0" vertical={false} />
        <XAxis dataKey="bucket" tick={{ fill: "#64748b", fontSize: 10, fontFamily: "IBM Plex Mono" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
        <YAxis domain={[-1, 1]} tick={{ fill: "#64748b", fontSize: 10, fontFamily: "IBM Plex Mono" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
        <Tooltip contentStyle={{ borderRadius: 2, border: "1px solid #e2e8f0", fontSize: 12 }} />
        <Area type="monotone" dataKey="avg_sentiment" stroke="#2563eb" fill="url(#sGrad)" strokeWidth={2} />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export function RiskBar({ data }) {
  return (
    <ResponsiveContainer width="100%" height={180}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
        <CartesianGrid strokeDasharray="2 4" stroke="#e2e8f0" vertical={false} />
        <XAxis dataKey="bucket" tick={{ fill: "#64748b", fontSize: 10, fontFamily: "IBM Plex Mono" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
        <YAxis tick={{ fill: "#64748b", fontSize: 10, fontFamily: "IBM Plex Mono" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
        <Tooltip contentStyle={{ borderRadius: 2, border: "1px solid #e2e8f0", fontSize: 12 }} />
        <Bar dataKey="avg_risk" fill="#dc2626" radius={[2, 2, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}

export function VolumeLine({ data }) {
  return (
    <ResponsiveContainer width="100%" height={180}>
      <LineChart data={data} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
        <CartesianGrid strokeDasharray="2 4" stroke="#e2e8f0" vertical={false} />
        <XAxis dataKey="bucket" tick={{ fill: "#64748b", fontSize: 10, fontFamily: "IBM Plex Mono" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
        <YAxis tick={{ fill: "#64748b", fontSize: 10, fontFamily: "IBM Plex Mono" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
        <Tooltip contentStyle={{ borderRadius: 2, border: "1px solid #e2e8f0", fontSize: 12 }} />
        <Line type="monotone" dataKey="posts" stroke="#0f172a" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}

export function CategoryDonut({ data }) {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <PieChart>
        <Pie data={data} dataKey="count" nameKey="category" innerRadius={55} outerRadius={90} paddingAngle={2}>
          {data.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
        </Pie>
        <Tooltip contentStyle={{ borderRadius: 2, border: "1px solid #e2e8f0", fontSize: 12 }} />
      </PieChart>
    </ResponsiveContainer>
  );
}

export function AreaHBar({ data }) {
  return (
    <ResponsiveContainer width="100%" height={Math.max(220, data.length * 32)}>
      <BarChart data={data} layout="vertical" margin={{ top: 4, right: 16, left: 8, bottom: 4 }}>
        <CartesianGrid strokeDasharray="2 4" stroke="#e2e8f0" horizontal={false} />
        <XAxis type="number" tick={{ fill: "#64748b", fontSize: 10, fontFamily: "IBM Plex Mono" }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} />
        <YAxis type="category" dataKey="state" tick={{ fill: "#334155", fontSize: 11 }} axisLine={{ stroke: "#e2e8f0" }} tickLine={false} width={120} />
        <Tooltip contentStyle={{ borderRadius: 2, border: "1px solid #e2e8f0", fontSize: 12 }} />
        <Bar dataKey="count" fill="#2563eb" radius={[0, 2, 2, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}

export { PALETTE };
